// export const BaseIp = 'http://192.168.29.113:8000/'     //---local path (URL)
export const BaseIp = 'https://warana.digitaltkiet.in/'     //---online path (URL)

export const IMG_BASE_URL = BaseIp + 'uploads/'     //---Image path (URL)

//===============================================================================================
//===============================================================================================

export const RegistrationAPI = BaseIp + "member/createMember";  //Student Registration API (POST)
export const StudentLoginAPI = BaseIp + "member/memberLogin";  //Student Login API (POST)
export const StudentRegFeeFormAPI = BaseIp + "registration/createRegistration";  //Student Reg Fee Payment API (POST)
export const ForgotPassword = BaseIp + "member/forgotPassword";  //Student Forgot Password API (POST)
export const ResetPasswordAPI = BaseIp + "member/resetPassword";  //Student Reset Password API (POST)

